// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

const bell = ({ ...props }) => (
  <svg width="25" height="24" viewBox="0 0 25 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5 15.5V10.5C18.5 7.43 16.87 4.86 14 4.18V3.5C14 2.67 13.33 2 12.5 2C11.67 2 11 2.67 11 3.5V4.18C8.14 4.86 6.5 7.42 6.5 10.5V15.5L4.5 17.5V18.5H20.5V17.5L18.5 15.5ZM12.5 21.5C13.6 21.5 14.5 20.6 14.5 19.5H10.5C10.5 20.6 11.4 21.5 12.5 21.5ZM8.5 16.5H16.5V10.5C16.5 8.02 14.99 6 12.5 6C10.01 6 8.5 8.02 8.5 10.5V16.5Z"
    />
  </svg>
);

const bellNotification = ({ ...props }) => (
  <svg width="25" height="25" viewBox="0 0 25 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 17V12C18 8.93 16.37 6.36 13.5 5.68V5C13.5 4.17 12.83 3.5 12 3.5C11.17 3.5 10.5 4.17 10.5 5V5.68C7.64 6.36 6 8.92 6 12V17L4 19V20H20V19L18 17ZM12 23C13.1 23 14 22.1 14 21H10C10 22.1 10.9 23 12 23ZM8 18H16V12C16 9.52 14.49 7.5 12 7.5C9.51 7.5 8 9.52 8 12V18Z"
    />
    <path
      d="M20 10.5C22.7614 10.5 25 8.26142 25 5.5C25 2.73858 22.7614 0.5 20 0.5C17.2386 0.5 15 2.73858 15 5.5C15 8.26142 17.2386 10.5 20 10.5Z"
      fill="#D82F4B"
      stroke="#0C273A"
      strokeWidth="2"
    />
  </svg>
);

const cash = ({ fillOverwrite, ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <radialGradient id="featuredGradient">
        <stop offset="0%" stopColor="#f0ddb5" />
        <stop offset="100%" stopColor="#b5a075" />
      </radialGradient>
    </defs>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM7.97 7.47C7.97 8.2 8.54 8.69 10.31 9.14C12.07 9.6 13.96 10.36 13.97 12.56C13.96 14.17 12.76 15.04 11.24 15.33V17H8.9V15.3C7.4 14.99 6.14 14.03 6.04 12.33H7.76C7.85 13.25 8.48 13.97 10.08 13.97C11.79 13.97 12.18 13.11 12.18 12.58C12.18 11.86 11.79 11.17 9.84 10.71C7.67 10.19 6.18 9.29 6.18 7.5C6.18 5.99 7.39 5.01 8.9 4.69V3H11.23V4.71C12.85 5.11 13.67 6.34 13.72 7.68H12.01C11.97 6.7 11.45 6.04 10.07 6.04C8.76 6.04 7.97 6.63 7.97 7.47Z"
      fill={fillOverwrite}
    />
  </svg>
);

const clock = ({ ...props }) => (
  <svg width="1.5em" height="1.5em" viewBox="-2 -2 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM9 5H10.5V10.25L15 12.92L14.25 14.15L9 11V5Z"
    />
  </svg>
);

const dollar = ({ ...props }) => (
  <svg width="14" height="24" viewBox="0 0 11 18" {...props}>
    <path
      d="M5.80031 7.9C3.53031 7.31 2.80031 6.7 2.80031 5.75C2.80031 4.66 3.81031 3.9 5.50031 3.9C7.28031 3.9 7.94031 4.75 8.00031 6H10.2103C10.1403 4.28 9.09031 2.7 7.00031 2.19V0H4.00031V2.16C2.06031 2.58 0.500312 3.84 0.500312 5.77C0.500312 8.08 2.41031 9.23 5.20031 9.9C7.70031 10.5 8.20031 11.38 8.20031 12.31C8.20031 13 7.71031 14.1 5.50031 14.1C3.44031 14.1 2.63031 13.18 2.52031 12H0.320312C0.440312 14.19 2.08031 15.42 4.00031 15.83V18H7.00031V15.85C8.95031 15.48 10.5003 14.35 10.5003 12.3C10.5003 9.46 8.07031 8.49 5.80031 7.9Z"
      fill="#3f7193"
    />
  </svg>
);

const Dollars = ({ ...props }) => (
  <svg
    width="75"
    height="72"
    viewBox="0 0 75 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_173:16367)">
      <g filter="url(#filter0_d_173:16367)">
        <rect
          width="68.4649"
          height="30.3332"
          transform="matrix(0.49745 -0.867493 0.87157 0.490271 7.42213 58.4287)"
          fill="#23CA78"
        />
        <rect
          x="1.36902"
          y="-0.377222"
          width="62.6613"
          height="25.8054"
          transform="matrix(0.49745 -0.867493 0.87157 0.490271 10.4865 58.3939)"
          fill="#23CA78"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M40.2291 28.1525L38.4473 27.1502L34.4857 28.2827L33.3143 30.3256L32.5313 29.8852L31.5212 31.6466L32.3042 32.087L31.3826 33.6942L30.5996 33.2537L29.5896 35.0152L30.3725 35.4556L29.201 37.4986L30.2482 41.4485L31.9316 42.3954L35.8932 41.263L37.0647 39.22L40.1965 40.9818L39.4435 42.2949L37.0903 42.9676L35.9874 42.3472L34.9773 44.1087L36.7994 45.1336L40.761 44.0012L41.9325 41.9583L42.8083 42.4509L43.8184 40.6895L42.9515 40.2018L43.8731 38.5947L44.7399 39.0823L45.75 37.3209L44.8832 36.8333L46.0547 34.7903L45.0075 30.8404L43.4035 29.9381L39.4419 31.0706L38.2704 33.1135L35.0502 31.3021L35.8032 29.9889L38.1565 29.3162L39.2191 29.914L40.2291 28.1525ZM34.5768 39.5573L32.2236 40.23L31.9786 40.0922L31.3566 37.7459L32.1096 36.4327L35.3298 38.2442L34.5768 39.5573ZM41.2133 39.2241L38.0815 37.4624L39.003 35.8552L42.1349 37.617L41.2133 39.2241ZM40.7661 32.7806L43.1194 32.108L43.2815 32.1992L43.9036 34.5455L43.1506 35.8587L40.0187 34.0969L40.7661 32.7806ZM34.0401 33.0635L37.2604 34.875L36.3388 36.4821L33.1186 34.6707L34.0401 33.0635Z"
          fill="#047870"
        />
      </g>
      <g filter="url(#filter1_d_173:16367)">
        <rect
          width="68.351"
          height="30.3835"
          transform="matrix(0.701234 -0.712932 0.71803 0.696012 2.79667 49.9592)"
          fill="#23CA78"
        />
        <rect
          x="1.41926"
          y="-0.0169194"
          width="62.5537"
          height="25.8515"
          transform="matrix(0.701234 -0.712932 0.71803 0.696012 5.47325 50.4934)"
          fill="#23CA78"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M42.1682 29.0704L40.6978 27.6451L36.5805 27.7268L34.9318 29.403L34.2857 28.7767L32.8642 30.2219L33.5103 30.8482L32.2134 32.1668L31.5673 31.5405L30.1458 32.9857L30.7919 33.612L29.1432 35.2881L29.1591 39.3763L30.5482 40.7229L34.6656 40.6412L36.3142 38.965L38.8987 41.4702L37.8389 42.5476L35.3932 42.5961L34.4831 41.7139L33.0616 43.1592L34.5652 44.6166L38.6825 44.5349L40.3312 42.8588L41.0539 43.5593L42.4754 42.1141L41.7601 41.4207L43.057 40.1022L43.7723 40.7956L45.1938 39.3503L44.4785 38.6569L46.1271 36.9808L46.1113 32.8926L44.7877 31.6096L40.6703 31.6913L39.0217 33.3674L36.3643 30.7916L37.424 29.7142L39.8698 29.6657L40.7467 30.5156L42.1682 29.0704ZM33.8229 38.6547L31.3772 38.7033L31.175 38.5073L31.1656 36.0789L32.2253 35.0015L34.8826 37.5773L33.8229 38.6547ZM40.3257 40.0304L37.7413 37.5252L39.0382 36.2066L41.6226 38.7118L40.3257 40.0304ZM41.5194 33.684L43.9652 33.6355L44.099 33.7652L44.1085 36.1936L43.0487 37.271L40.4643 34.7659L41.5194 33.684ZM34.9428 32.2368L37.6002 34.8127L36.3032 36.1312L33.6459 33.5554L34.9428 32.2368Z"
          fill="#047870"
        />
      </g>
      <g filter="url(#filter2_d_173:16367)">
        <rect
          width="68.4815"
          height="30.3254"
          transform="matrix(0.867599 -0.497265 0.50274 0.864438 0.339701 40.0876)"
          fill="#23CA78"
        />
        <rect
          x="1.37034"
          y="0.367173"
          width="62.677"
          height="25.7982"
          transform="matrix(0.867599 -0.497265 0.50274 0.864438 2.62219 40.9651)"
          fill="#23CA78"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M43.9334 30.5418L42.9059 28.775L38.9195 27.7488L36.8759 28.9201L36.4243 28.1437L34.6622 29.1537L35.1138 29.93L33.5061 30.8515L33.0545 30.0751L31.2924 31.0851L31.7439 31.8614L29.7003 33.0328L28.6024 36.973L29.5731 38.6422L33.5594 39.6685L35.6031 38.4971L37.4092 41.6026L36.0956 42.3555L33.7276 41.7459L33.0916 40.6523L31.3295 41.6623L32.3803 43.469L36.3666 44.4952L38.4103 43.3239L38.9153 44.1923L40.6774 43.1823L40.1775 42.3228L41.7852 41.4013L42.2851 42.2609L44.0472 41.2509L43.5473 40.3914L45.591 39.22L46.6889 35.2798L45.764 33.6894L41.7776 32.6631L39.734 33.8345L37.8769 30.6414L39.1906 29.8885L41.5585 30.4981L42.1713 31.5517L43.9334 30.5418ZM33.2891 37.5298L30.9211 36.9202L30.7799 36.6773L31.432 34.3368L32.7457 33.5839L34.6027 36.7769L33.2891 37.5298ZM39.1752 40.5993L37.3691 37.4938L38.9768 36.5724L40.7829 39.6778L39.1752 40.5993ZM42.0525 34.8095L44.4205 35.4191L44.514 35.5799L43.8618 37.9205L42.5482 38.6734L40.7421 35.568L42.0525 34.8095ZM36.1148 31.6513L37.9718 34.8444L36.3642 35.7659L34.5071 32.5728L36.1148 31.6513Z"
          fill="#047870"
        />
      </g>
      <g filter="url(#filter3_d_173:16367)">
        <rect
          width="68.5726"
          height="30.2847"
          transform="matrix(0.966395 -0.257062 0.260587 0.96545 0.589811 30.3625)"
          fill="#23CA78"
        />
        <rect
          x="1.22698"
          y="0.708389"
          width="62.7631"
          height="25.761"
          transform="matrix(0.966395 -0.257062 0.260587 0.96545 2.61606 31.431)"
          fill="#23CA78"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M45.1868 32.3428L44.6549 30.3722L41.072 28.3567L38.7926 28.9631L38.5588 28.0972L36.5935 28.6199L36.8272 29.4859L35.034 29.9628L34.8003 29.0969L32.8349 29.6197L33.0687 30.4856L30.7892 31.092L28.7015 34.6159L29.204 36.4776L32.7869 38.4931L35.0663 37.8868L36.0012 41.3504L34.536 41.7402L32.4077 40.5429L32.0785 39.3232L30.1131 39.846L30.657 41.8611L34.24 43.8766L36.5194 43.2703L36.7808 44.2389L38.7462 43.7161L38.4874 42.7574L40.2806 42.2804L40.5394 43.2391L42.5047 42.7163L42.246 41.7576L44.5254 41.1513L46.6132 37.6274L46.1344 35.8535L42.5514 33.838L40.272 34.4443L39.3108 30.8829L40.7759 30.4932L42.9042 31.6904L43.2214 32.8656L45.1868 32.3428ZM33.0833 36.3579L30.955 35.1606L30.8819 34.8897L32.122 32.7965L33.5872 32.4067L34.5485 35.9681L33.0833 36.3579ZM37.9686 40.8351L37.0337 37.3714L38.8268 36.8944L39.7617 40.3581L37.9686 40.8351ZM42.2574 35.9819L44.3857 37.1791L44.4341 37.3585L43.1939 39.4518L41.7288 39.8415L40.7939 36.3778L42.2574 35.9819ZM37.3454 31.4057L38.3066 34.9671L36.5135 35.4441L35.5522 31.8827L37.3454 31.4057Z"
          fill="#047870"
        />
      </g>
      <g filter="url(#filter4_d_173:16367)">
        <rect
          x="3.38255"
          y="21.4261"
          width="67.1875"
          height="29.3182"
          fill="#23CA78"
        />
        <rect
          x="6.24887"
          y="23.6477"
          width="61.4549"
          height="24.875"
          fill="#23CA78"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M45.0637 34.3772V32.4013L42.189 29.624H39.878V28.7557H37.8853V29.624H36.0673V28.7557H34.0747V29.624H31.7636L28.8889 32.4013V34.2681L31.7636 37.0453H34.0747V40.5185H32.5892L30.8816 38.8687V37.6457H28.8889V39.6663L31.7636 42.4436H34.0747V43.4148H36.0673V42.4535H37.8853V43.4148H39.878V42.4535H42.189L45.0637 39.6762V37.8975L42.189 35.1202H39.878V31.5491H41.3635L43.0711 33.1988V34.3772H45.0637ZM32.5892 35.1215L30.8816 33.4717V33.2001L32.5892 31.5503H34.0747V35.1215H32.5892ZM36.0673 40.5259V37.0528H37.8853V40.5259H36.0673ZM41.3635 37.0528L43.0711 38.7025V38.8824L41.3635 40.5321H39.878V37.059L41.3635 37.0528ZM37.8853 31.5491V35.1202H36.0673V31.5491H37.8853Z"
          fill="#047870"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_173:16367"
        x="6.42213"
        y="-0.964081"
        width="62.4953"
        height="76.2643"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_173:16367"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_173:16367"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_173:16367"
        x="1.79667"
        y="1.22958"
        width="71.7462"
        height="71.8769"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_173:16367"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_173:16367"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_173:16367"
        x="-0.660299"
        y="6.03406"
        width="76.6603"
        height="62.2679"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_173:16367"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_173:16367"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_173:16367"
        x="-0.410189"
        y="12.7352"
        width="76.16"
        height="48.8658"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_173:16367"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_173:16367"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_173:16367"
        x="2.38255"
        y="21.4261"
        width="69.1875"
        height="31.3182"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_173:16367"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_173:16367"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_173:16367">
        <rect width="75" height="72" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const live = () => {
  const Pulse = styled.svg`
    position: absolute;
    animation: center-animate 2.5s ease infinite;

    @media screen and (prefers-reduced-motion: reduce) {
      animation: none;
      opacity: 1;
      transform: scale(1.4);
    }

    @keyframes center-animate {
      0% {
        opacity: 0;
        transform: scale(0);
      }
      60% {
        opacity: 1;
        transform: scale(1.3);
      }
      100% {
        transform: scale(1.3);
        opacity: 0;
      }
    }
  `;

  const Wrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
    z-index: 1;
  `;

  return (
    <Wrapper>
      <svg
        width="10"
        height="10"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.994 0C2.682 0 0 2.688 0 6C0 9.312 2.682 12 5.994 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 5.994 0Z"
          fill="#23CA78"
        />
      </svg>
      <Pulse
        width="12"
        height="12"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="10" cy="10" r="9" stroke="#23CA78" strokeWidth="2" />
      </Pulse>
    </Wrapper>
  );
};

const results = ({ ...props }) => (
  <svg width="1.5em" height="1.5em" viewBox="-3 0 24 24" {...props}>
    <path d="M15 12H14.32L12.32 14H14.23L16 16H2L3.78 14H5.83L3.83 12H3L0 15V19C0 20.1 0.89 21 1.99 21H16C17.1 21 18 20.11 18 19V15L15 12ZM16 19H2V18H16V19ZM8.34 14.02C8.73 14.41 9.36 14.41 9.75 14.02L16.11 7.66001C16.5 7.27001 16.5 6.64001 16.11 6.25001L11.16 1.30001C10.78 0.900011 10.15 0.900011 9.76 1.29001L3.39 7.66001C3 8.05001 3 8.68001 3.39 9.07001L8.34 14.02ZM10.46 3.41001L14 6.95001L9.05 11.9L5.51 8.36001L10.46 3.41001Z" />
  </svg>
);

const trophy = ({ ...props }) => (
  <svg width="1.5em" height="1.5em" viewBox="-2 -2 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 0C15.1 0 14 1 14 2H6C6 1 4.9 0 4 0H0V9C0 10 1 11 2 11H4.2C4.6 13 5.9 14.7 9 15V17.08C6 17.54 6 20 6 20H14C14 20 14 17.54 11 17.08V15C14.1 14.7 15.4 13 15.8 11H18C19 11 20 10 20 9V0H16ZM4 9H2V2H4V9ZM16 9H18V2H16V9Z"
    />
  </svg>
);

const watching = ({ ...props }) => (
  <svg width="1.5em" height="1.5em" viewBox="0 -4 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.5C1.73 3.11 6 0 11 0C16 0 20.27 3.11 22 7.5C20.27 11.89 16 15 11 15C6 15 1.73 11.89 0 7.5ZM19.82 7.5C18.17 4.13 14.79 2 11 2C7.21 2 3.83 4.13 2.18 7.5C3.83 10.87 7.21 13 11 13C14.79 13 18.17 10.87 19.82 7.5ZM11 5C12.38 5 13.5 6.12 13.5 7.5C13.5 8.88 12.38 10 11 10C9.62 10 8.5 8.88 8.5 7.5C8.5 6.12 9.62 5 11 5ZM6.5 7.5C6.5 5.02 8.52 3 11 3C13.48 3 15.5 5.02 15.5 7.5C15.5 9.98 13.48 12 11 12C8.52 12 6.5 9.98 6.5 7.5Z"
    />
  </svg>
);

const starFilled = ({ ...props }) => (
  <svg width="0.75em" height="0.75em" viewBox="0 0 12 13" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.87L6.405 3.56 5 0.25 3.595 3.565 0 3.87 2.73 6.235 1.91 9.75 5 7.885 8.09 9.75 7.275 6.235z"
    />
  </svg>
);

const starHalf = ({ ...props }) => (
  <svg width="0.75em" height="0.75em" viewBox="0 0 12 13" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.62l-3.595-.31L5 0 3.595 3.315 0 3.62l2.73 2.365L1.91 9.5 5 7.635 8.09 9.5l-.815-3.515L10 3.62zM5 6.7V2.05l.855 2.02 2.19.19-1.66 1.44.5 2.14L5 6.7z"
    />
  </svg>
);

const starEmpty = ({ ...props }) => (
  <svg width="0.75em" height="0.75em" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.87l-3.595-.31L5 .25 3.595 3.565 0 3.87l2.73 2.365-.82 3.515L5 7.885 8.09 9.75l-.815-3.515L10 3.87zM5 6.95L3.12 8.085l.5-2.14-1.66-1.44 2.19-.19L5 2.3l.855 2.02 2.19.19-1.66 1.44.5 2.14L5 6.95z"
    />
  </svg>
);

const tick = ({ ...props }) => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M5.6 10.6L1.4 6.4L0 7.8L5.6 13.4L17.6 1.4L16.2 0L5.6 10.6Z" />
  </svg>
);

const tickCircleFilled = ({ ...props }) => (
  <svg width="0.75em" height="0.75em" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm2.295 2.79L5 7.085l-1.295-1.29L3 6.5l2 2 4-4-.705-.71z"
    />
  </svg>
);

const crossCircle = ({ ...props }) => (
  <svg width="0.75em" height="0.75em" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.295 4L6 5.295 4.705 4 4 4.705 5.295 6 4 7.295 4.705 8 6 6.705 7.295 8 8 7.295 6.705 6 8 4.705 7.295 4zM6 1C3.235 1 1 3.235 1 6s2.235 5 5 5 5-2.235 5-5-2.235-5-5-5zm0 9c-2.205 0-4-1.795-4-4s1.795-4 4-4 4 1.795 4 4-1.795 4-4 4z"
    />
  </svg>
);

const communityScore = ({ ...props }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
    />
  </svg>
);

const difficulty = ({ ...props }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.112 2.751C6.45-.42 11.522-.903 15.398 1.582l-1.85 1.23c-3.158-1.58-6.978-.902-9.4 1.668-2.422 2.57-2.873 6.423-1.11 9.482h13.86c1.342-2.33 1.425-5.177.22-7.58l1.23-1.85.01-.01c2.045 3.153 2.149 7.186.27 10.44-.358.621-1.022 1.003-1.74 1H3.038c-.71-.004-1.365-.385-1.72-1-2.285-3.998-1.544-9.039 1.794-12.21zm13.936.131l-5.66 8.49c-.375.376-.884.587-1.415.587-.53 0-1.04-.211-1.415-.587-.375-.375-.586-.884-.586-1.415 0-.53.21-1.04.586-1.415l8.49-5.66z"
    />
  </svg>
);

const history = ({ ...props }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C7.03 0 3 4.03 3 9H0l3.89 3.89.07.14L8 9H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C7.27 16.99 9.51 18 12 18c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V5H11z"
    />
  </svg>
);

const shield = ({ ...props }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      id="7f1xpfmcva"
      d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17l-2.59-2.58z"
    />
  </svg>
);

const snowflake = ({ ...props }) => (
  <svg width="0.75em" height="0.75em" viewBox="0 0 13 11" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4.5L7.915 4.5 9.535 2.88 8.83 2.17 6.5 4.5 5.5 4.5 5.5 3.5 7.83 1.17 7.12 0.465 5.5 2.085 5.5 0 4.5 0 4.5 2.085 2.88 0.465 2.17 1.17 4.5 3.5 4.5 4.5 3.5 4.5 1.17 2.17 0.465 2.88 2.085 4.5 0 4.5 0 5.5 2.085 5.5 0.465 7.12 1.17 7.83 3.5 5.5 4.5 5.5 4.5 6.5 2.17 8.83 2.88 9.535 4.5 7.915 4.5 10 5.5 10 5.5 7.915 7.12 9.535 7.83 8.83 5.5 6.5 5.5 5.5 6.5 5.5 8.83 7.83 9.535 7.12 7.915 5.5 10 5.5z"
    />
  </svg>
);

const fire = ({ ...props }) => (
  <svg width="11" height="11" viewBox="0 0 10 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7512 7.46656C11.9838 7.69817 12.2199 7.93327 12.4244 8.2L12.3744 8.21C12.7044 8.59 12.9744 9 13.1744 9.46L13.3044 9.72C14.2544 12 13.6044 14.66 11.8044 16.32C10.1944 17.8 7.94436 18.19 5.84436 17.92C3.87436 17.67 2.04436 16.43 1.00436 14.7C0.684361 14.17 0.424361 13.57 0.284361 12.97C0.114361 12.47 0.054361 11.97 0.014361 11.47C-0.125639 9.3 0.764361 7 2.40436 5.64C1.65436 7.28 1.83436 9.33 2.93436 10.76C2.98436 10.83 3.02436 10.88 3.08436 10.93C3.26436 11.09 3.50436 11.15 3.72436 11.05C3.92436 10.97 4.07436 10.77 4.07436 10.55C4.07436 10.42 4.03436 10.32 3.99436 10.22C2.79436 7.07 3.79436 3.4 6.33436 1.32C7.03436 0.75 7.87436 0.23 8.78436 0C7.87436 1.85 8.17436 4.26 9.63436 5.72C9.97586 6.0615 10.3526 6.34423 10.7296 6.62712C11.0481 6.86612 11.3667 7.10523 11.6644 7.38C11.6932 7.40884 11.7222 7.43767 11.7512 7.46656ZM8.24436 15.1C8.59436 15 9.04436 14.74 9.32436 14.5H9.31436C9.91436 13.95 10.2644 13.05 10.2344 12.23C10.2344 12.08 10.2144 11.94 10.1744 11.8C10.0117 10.9151 9.4511 10.4197 8.86991 9.90612C8.55786 9.63036 8.23987 9.34935 7.97436 9C7.74436 8.7 7.54436 8.32 7.37436 7.94C7.09436 8.63 7.07436 9.26 7.19436 10C7.23167 10.221 7.2838 10.4329 7.33516 10.6417C7.46276 11.1604 7.58557 11.6596 7.46436 12.23C7.26436 13.12 6.56436 14 5.37436 14.28C6.04436 14.94 7.14436 15.5 8.24436 15.1Z"
    />
  </svg>
);

const wallet = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 5V7.28C21.09 7.63 21.5 8.26 21.5 9V15C21.5 15.74 21.09 16.37 20.5 16.72V19C20.5 20.1 19.6 21 18.5 21H4.5C3.39 21 2.5 20.1 2.5 19V5C2.5 3.9 3.39 3 4.5 3H18.5C19.6 3 20.5 3.9 20.5 5ZM12.5 15H19.5V9H12.5V15ZM4.5 19V5H18.5V7H12.5C11.4 7 10.5 7.9 10.5 9V15C10.5 16.1 11.4 17 12.5 17H18.5V19H4.5ZM14 12C14 11.1716 14.6716 10.5 15.5 10.5C16.3284 10.5 17 11.1716 17 12C17 12.8284 16.3284 13.5 15.5 13.5C14.6716 13.5 14 12.8284 14 12Z"
    />
  </svg>
);

const settings = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2293 12C19.2293 12.34 19.1993 12.66 19.1593 12.98L21.2693 14.63C21.4593 14.78 21.5093 15.05 21.3893 15.27L19.3893 18.73C19.2993 18.89 19.1293 18.98 18.9593 18.98C18.8993 18.98 18.8393 18.97 18.7793 18.95L16.2893 17.95C15.7693 18.34 15.2093 18.68 14.5993 18.93L14.2193 21.58C14.1893 21.82 13.9793 22 13.7293 22H9.72933C9.47933 22 9.26933 21.82 9.23933 21.58L8.85933 18.93C8.24933 18.68 7.68933 18.35 7.16933 17.95L4.67933 18.95C4.62933 18.97 4.56933 18.98 4.50933 18.98C4.32933 18.98 4.15933 18.89 4.06933 18.73L2.06933 15.27C1.94933 15.05 1.99933 14.78 2.18933 14.63L4.29933 12.98C4.25933 12.66 4.22933 12.33 4.22933 12C4.22933 11.67 4.25933 11.34 4.29933 11.02L2.18933 9.37C1.99933 9.22 1.93933 8.95 2.06933 8.73L4.06933 5.27C4.15933 5.11 4.32933 5.02 4.49933 5.02C4.55933 5.02 4.61933 5.03 4.67933 5.05L7.16933 6.05C7.68933 5.66 8.24933 5.32 8.85933 5.07L9.23933 2.42C9.26933 2.18 9.47933 2 9.72933 2H13.7293C13.9793 2 14.1893 2.18 14.2193 2.42L14.5993 5.07C15.2093 5.32 15.7693 5.65 16.2893 6.05L18.7793 5.05C18.8293 5.03 18.8893 5.02 18.9493 5.02C19.1293 5.02 19.2993 5.11 19.3893 5.27L21.3893 8.73C21.5093 8.95 21.4593 9.22 21.2693 9.37L19.1593 11.02C19.1993 11.34 19.2293 11.66 19.2293 12ZM17.2293 12C17.2293 11.79 17.2193 11.58 17.1793 11.27L17.0393 10.14L17.9293 9.44L18.9993 8.59L18.2993 7.38L17.0293 7.89L15.9693 8.32L15.0593 7.62C14.6593 7.32 14.2593 7.09 13.8293 6.91L12.7693 6.48L12.6093 5.35L12.4193 4H11.0293L10.8293 5.35L10.6693 6.48L9.60933 6.91C9.19933 7.08 8.78933 7.32 8.35933 7.64L7.45933 8.32L6.41933 7.9L5.14933 7.39L4.44933 8.6L5.52933 9.44L6.41933 10.14L6.27933 11.27C6.24933 11.57 6.22933 11.8 6.22933 12C6.22933 12.2 6.24933 12.43 6.27933 12.74L6.41933 13.87L5.52933 14.57L4.44933 15.41L5.14933 16.62L6.41933 16.11L7.47933 15.68L8.38933 16.38C8.78933 16.68 9.18933 16.91 9.61933 17.09L10.6793 17.52L10.8393 18.65L11.0293 20H12.4293L12.6293 18.65L12.7893 17.52L13.8493 17.09C14.2593 16.92 14.6693 16.68 15.0993 16.36L15.9993 15.68L17.0393 16.1L18.3093 16.61L19.0093 15.4L17.9293 14.56L17.0393 13.86L17.1793 12.73C17.2093 12.43 17.2293 12.21 17.2293 12ZM11.7293 8C9.51933 8 7.72933 9.79 7.72933 12C7.72933 14.21 9.51933 16 11.7293 16C13.9393 16 15.7293 14.21 15.7293 12C15.7293 9.79 13.9393 8 11.7293 8ZM9.72933 12C9.72933 13.1 10.6293 14 11.7293 14C12.8293 14 13.7293 13.1 13.7293 12C13.7293 10.9 12.8293 10 11.7293 10C10.6293 10 9.72933 10.9 9.72933 12Z"
    />
  </svg>
);

const rules = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16H16V18H8V16ZM8 12H16V14H8V12ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
    />
  </svg>
);

const home = ({ ...props }) => (
  <svg width="25" height="24" viewBox="0 0 25 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 13H2.5L12.5 4L22.5 13H19.5V21H13.5V15H11.5V21H5.5V13ZM17.5 11.19L12.5 6.69L7.5 11.19V19H9.5V13H15.5V19H17.5V11.19Z"
    />
  </svg>
);

const challenges = ({ ...props }) => (
  <svg width="25" height="24" viewBox="0 0 25 24" {...props}>
    <path d="M5.59973 10H1.51184V12.1766H5.59973V14.5L9.09973 11L5.59973 7.5V10Z" />
    <path d="M14.923 13.5C10.7463 13.5 7.09973 15.9999 7.09973 18V20.5H22.6877L22.5997 18C22.5997 15.9999 19.0997 13.5 14.923 13.5ZM9.09973 18.5C9.09973 16.9999 11.9244 15.3067 14.923 15.3067C17.9217 15.3067 20.5997 17.1764 20.5997 18.5H14.923H9.09973ZM14.923 11.6806C17.1142 11.6806 18.5997 10.0807 18.5997 7.93991C18.5997 5.91662 17.0606 4.24991 14.9197 4.24991C12.7789 4.24991 11.0997 5.87991 11.0997 7.93991C11.0997 9.99991 12.7318 11.6806 14.923 11.6806ZM14.9197 6.13258C16.1309 6.13258 16.7149 7.21074 16.6997 7.93991C16.6806 8.86038 16.0997 9.83723 14.923 9.83723C13.71 9.83723 12.9997 8.92794 12.9997 7.93991C12.9997 6.95187 13.7085 6.13258 14.9197 6.13258Z" />
  </svg>
);

const chat = ({ ...props }) => (
  <svg width="25" height="24" viewBox="0 0 25 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.09973 4H20.0997C21.1997 4 22.0997 4.9 22.0997 6V18C22.0997 19.1 21.1997 20 20.0997 20H6.09973L2.09973 24V6C2.09973 4.9 2.99973 4 4.09973 4ZM6.09973 18H20.0997V6H4.09973V20L6.09973 18Z"
    />
  </svg>
);

const player = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM14.1 8C14.1 6.84 13.16 5.9 12 5.9C10.84 5.9 9.9 6.84 9.9 8C9.9 9.16 10.84 10.1 12 10.1C13.16 10.1 14.1 9.16 14.1 8ZM18.1 17C18.1 16.36 14.97 14.9 12 14.9C9.03 14.9 5.9 16.36 5.9 17V18.1H18.1V17ZM4 17C4 14.34 9.33 13 12 13C14.67 13 20 14.34 20 17V20H4V17Z"
    />
  </svg>
);

const card = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#2f9bd8" {...props}>
    <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" />
  </svg>
);

const idVerification = () => (
  <svg
    width="120"
    height="100"
    viewBox="0 0 120 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M13.0625 10H97.9375L104 16.0625V70.625L97.9375 76.6875H13.0625L7 70.625V16.0625L13.0625 10Z"
      fill="#3F7193"
    />
    <path
      d="M6.0625 15.1562H90.9375L97 21.2188V75.7812L90.9375 81.8438H6.0625L0 75.7812V21.2188L6.0625 15.1562Z"
      fill="#D4E2EC"
    />
    <path opacity="0.2" d="M20 82L45.0952 15H82L57.3968 82H20Z" fill="white" />
    <path
      d="M35.9961 35.5332C35.9961 41.3929 31.2464 46.1426 25.3867 46.1426C19.527 46.1426 14.7773 41.3929 14.7773 35.5332C14.7773 29.6735 19.527 24.9238 25.3867 24.9238C31.2464 24.9238 35.9961 29.6735 35.9961 35.5332Z"
      fill="#3F7193"
    />
    <path
      d="M42.4375 71.7188H8.14648V59.8779L15.2011 53.5312H36.2758L42.4375 59.8779V71.7188Z"
      fill="#3F7193"
    />
    <path d="M75.7812 65.6562H81.8438V71.7188H75.7812V65.6562Z" fill="white" />
    <path d="M62.709 65.6562H68.7715V71.7188H62.709V65.6562Z" fill="white" />
    <path d="M49.6367 65.6562H55.6992V71.7188H49.6367V65.6562Z" fill="white" />
    <rect
      x="48.5"
      y="25.9023"
      width="37.5117"
      height="5.30469"
      fill="#3F7193"
    />
    <rect
      x="48.5"
      y="47.8789"
      width="10.6094"
      height="5.30469"
      fill="#3F7193"
    />
    <rect
      x="48.5"
      y="36.8906"
      width="10.6094"
      height="5.30469"
      fill="#3F7193"
    />
    <rect
      x="62.1406"
      y="47.8789"
      width="23.8711"
      height="5.30469"
      fill="#3F7193"
    />
    <rect
      x="62.1406"
      y="36.8906"
      width="23.8711"
      height="5.30469"
      fill="#3F7193"
    />
    <rect
      x="74"
      y="76.627"
      width="32"
      height="32"
      transform="rotate(-45 74 76.627)"
      fill="#F6BB43"
    />
    <path d="M94 65L95 80H98L99 65H94Z" fill="white" />
    <rect x="94.5" y="83" width="4" height="4" fill="white" />
  </svg>
);

const goldTrophy = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.8333 4.16667H14.1667V2.5H5.83333V4.16667H4.16667C3.25 4.16667 2.5 4.91667 2.5 5.83333V6.66667C2.5 8.79167 4.1 10.525 6.15833 10.7833C6.68333 12.0333 7.80833 12.975 9.16667 13.25V15.8333H5.83333V17.5H14.1667V15.8333H10.8333V13.25C12.1917 12.975 13.3167 12.0333 13.8417 10.7833C15.9 10.525 17.5 8.79167 17.5 6.66667V5.83333C17.5 4.91667 16.75 4.16667 15.8333 4.16667ZM4.16667 6.66667V5.83333H5.83333V9.01667C4.86667 8.66667 4.16667 7.75 4.16667 6.66667ZM15.8333 6.66667C15.8333 7.75 15.1333 8.66667 14.1667 9.01667V5.83333H15.8333V6.66667Z"
      fill="#F6BB43"
    />
  </svg>
);

const linkedAccounts = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 5V19H5V5H19ZM19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 12C10.35 12 9 10.65 9 9C9 7.35 10.35 6 12 6C13.65 6 15 7.35 15 9C15 10.65 13.65 12 12 12ZM12 8C11.45 8 11 8.45 11 9C11 9.55 11.45 10 12 10C12.55 10 13 9.55 13 9C13 8.45 12.55 8 12 8ZM18 18H6V16.47C6 13.97 9.97 12.89 12 12.89C14.03 12.89 18 13.97 18 16.47V18ZM8.31 16H15.69C15 15.44 13.31 14.88 12 14.88C10.69 14.88 8.99 15.44 8.31 16Z"
      fill="#3f7193"
    />
  </svg>
);

const share = ({ ...props }) => (
  <svg
    width="19"
    height="24"
    viewBox="0 0 19 24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 4L9.5 0L5.5 4H8.5V13H10.5V4H13.5ZM12.5 6H16.5C17.6 6 18.5 6.9 18.5 8V22C18.5 23.1 17.6 24 16.5 24H2.5C1.4 24 0.5 23.1 0.5 22V8C0.5 6.9 1.4 6 2.5 6H6.5V7.99H2.5V22.02H16.5V7.99H12.5V6Z"
    />
  </svg>
);

const information = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" />
  </svg>
);

const messages = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3393 15.0103L23.282 10.0535L2.07586 1.57527L10.5541 22.7814L15.5109 17.8387L6.3185 5.81791L18.3393 15.0103ZM19.7252 10.7818L12.138 7.74831L18.1625 12.3586L19.7252 10.7818ZM8.25597 11.6445L11.2895 19.2317L12.8592 17.6619L8.25597 11.6445Z"
    />
  </svg>
);

const group = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31C9.95 14.93 10.97 14.75 12 14.75C13.03 14.75 14.05 14.93 15.02 15.31C15.79 15.61 15.83 15.77 15.93 16H8.07ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6Z" />
  </svg>
);

const trophyOutline = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9.5 2.5H8.5V1.5H3.5V2.5H2.5C1.95 2.5 1.5 2.95 1.5 3.5V4C1.5 5.275 2.46 6.315 3.695 6.47C4.01 7.22 4.685 7.785 5.5 7.95V9.5H3.5V10.5H8.5V9.5H6.5V7.95C7.315 7.785 7.99 7.22 8.305 6.47C9.54 6.315 10.5 5.275 10.5 4V3.5C10.5 2.95 10.05 2.5 9.5 2.5ZM2.5 4V3.5H3.5V5.41C2.92 5.2 2.5 4.65 2.5 4ZM6 7C5.175 7 4.5 6.325 4.5 5.5V2.5H7.5V5.5C7.5 6.325 6.825 7 6 7ZM9.5 4C9.5 4.65 9.08 5.2 8.5 5.41V3.5H9.5V4Z" />
  </svg>
);

const trophyMarketing = (props) => (
  <svg
    width="91"
    height="94"
    viewBox="0 0 91 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M73.5976 0H16.605V57.9899H73.5976V0Z" fill="#F6BB43" />
    <path
      d="M57.2346 82.9511H32.9673V86.1005H57.2346V82.9511Z"
      fill="#F6BB43"
    />
    <path d="M73.5976 86.1H16.605V94H73.5976V86.1Z" fill="#F6BB43" />
    <path d="M50.4234 72.1191H39.7788V82.95H50.4234V72.1191Z" fill="#C9812D" />
    <path
      d="M73.5976 57.9916L59.7107 72.1202H30.4906L16.605 57.9916H73.5976Z"
      fill="#F6BB43"
    />
    <path
      d="M16.7935 46.6202V53.1534L0 36.0661V21.805H16.6047V27.3304H6.68251V36.0661H6.71895L16.7935 46.6202Z"
      fill="#C9812D"
    />
    <path
      d="M73.4087 46.6202V53.1534L90.2022 36.0661V21.805H73.5974V27.3304H83.5197V36.0661H83.4832L73.4087 46.6202Z"
      fill="#C9812D"
    />
    <path d="M73.5976 86.1H16.605V90.8506H73.5976V86.1Z" fill="#C9812D" />
    <path
      d="M83.5201 26.5729H6.68164V27.3132H83.5201V26.5729Z"
      fill="#F6BB43"
    />
    <path d="M73.5976 88.1047H16.605V88.845H73.5976V88.1047Z" fill="#F6BB43" />
    <path
      d="M24.4492 52.0998L24.4492 14.6022H20.4572L20.4572 52.0998H24.4492Z"
      fill="white"
    />
    <path
      d="M2.00635 34.0913L2.00635 24.1491H1.14337L1.14337 34.0913H2.00635Z"
      fill="white"
    />
    <path d="M85.5601 34.0897V26.5711H84.6971V34.0897H85.5601Z" fill="white" />
    <path
      d="M59.7174 32.2849V28.7382L54.8011 23.7137H50.868V22.1177H47.4555V23.7137H44.3322V22.1177H40.9197V23.7137H36.9866L32.0703 28.7382V32.1076L36.9866 37.1321H40.9197V43.3979H38.3748L35.4828 40.4424V38.2552H32.0703V41.9201L36.9866 46.9447H40.9197V48.6589H44.3322V46.9447H47.4555V48.6589H50.868V46.9447H54.8011L59.7174 41.9201V38.7281L54.8011 33.7036H50.868V27.2013H53.4129L56.3049 30.1569V32.2849H59.7174ZM38.3748 33.6445L35.4828 30.6889V30.216L38.3748 27.2604H40.9197V33.7036H38.3748V33.6445ZM44.3322 43.3979V37.1321H47.4555V43.3979H44.3322ZM53.3551 37.1321L56.2471 40.0877V40.3832L53.3551 43.3388H50.8102V37.1321H53.3551ZM47.4555 33.6445H44.3322V27.2013H47.4555V33.6445Z"
      fill="#7B2D0F"
    />
  </svg>
);

export default {
  bell,
  bellNotification,
  cash,
  card,
  chat,
  challenges,
  clock,
  communityScore,
  crossCircle,
  difficulty,
  dollar,
  Dollars,
  fire,
  goldTrophy,
  group,
  home,
  history,
  idVerification,
  information,
  linkedAccounts,
  live,
  messages,
  player,
  results,
  rules,
  settings,
  shield,
  share,
  snowflake,
  starEmpty,
  starFilled,
  starHalf,
  tick,
  tickCircleFilled,
  trophy,
  trophyOutline,
  trophyMarketing,
  wallet,
  watching,
};
